// import React from "react";
// import Bannerheader from "../pages/Bannerheader";

// import { Footer } from "../navbar/Footer";

// const OrderPolicy = () => {
//   return (
//     <>
//       <Bannerheader />
//       <div className="container py-5">
//         <h1>Order Policy</h1>

//         <h3>Order Confirmation</h3>
//         <p>Orders are confirmed only after successful payment.</p>

//         <h3>Shipping</h3>
//         <p>
//           Orders will be processed within 2-5 business days. Delivery time may
//           vary based on location.
//         </p>

//         <h3>Order Cancellation</h3>
//         <p>Orders can be cancelled within 24 hours of placing the order.</p>
//       </div>
//       <Footer />
//     </>
//   );
// };

// export default OrderPolicy;

import React from "react";
import Bannerheader from "../pages/Bannerheader";
import { Footer } from "../navbar/Footer";

const OrderPolicy = () => {
  return (
    <>
      <Bannerheader />

      {/* Document Style Container */}
      <div className="bg-light py-4">
        <div className="container">
          {/* Document Paper Effect */}
          <div className="bg-white shadow-sm rounded-3 overflow-hidden">
            {/* Document Header */}
            <div className="border-bottom p-4 p-md-5 text-center bg-primary bg-opacity-10">
              <h1 className="display-5 fw-bold text-dark mb-2">ORDER POLICY</h1>
              <p className="text-muted mb-0">Last Updated: Feb 1, 2026</p>
              <div className="mt-3">
                <span className="badge bg-primary px-3 py-2">Version 2.0</span>
              </div>
            </div>

            {/* Document Content */}
            <div className="p-4 p-md-5">
              {/* Introduction */}
              <div className="mb-5">
                <p className="lead text-secondary">
                  This Order Policy outlines the terms and conditions governing
                  the placement, processing, and fulfillment of orders through
                  our platform. Please read this document carefully before
                  placing an order.
                </p>
              </div>

              {/* Table of Contents */}
              <div className="bg-light p-4 rounded-3 mb-5">
                <h6 className="fw-bold mb-3">CONTENTS</h6>
                <div className="row">
                  <div className="col-md-4">
                    <ul className="list-unstyled small">
                      <li className="mb-2">1.0 Order Confirmation</li>
                      <li className="mb-2">2.0 Order Processing</li>
                      <li className="mb-2">3.0 Shipping Information</li>
                    </ul>
                  </div>
                  <div className="col-md-4">
                    <ul className="list-unstyled small">
                      <li className="mb-2">4.0 Order Cancellation</li>
                      <li className="mb-2">5.0 Payment Terms</li>
                      <li className="mb-2">6.0 Order Modifications</li>
                    </ul>
                  </div>
                  <div className="col-md-4">
                    <ul className="list-unstyled small">
                      <li className="mb-2">7.0 Tracking Information</li>
                      <li className="mb-2">8.0 Delivery Issues</li>
                      <li className="mb-2">9.0 Contact Information</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Section 1 - Order Confirmation */}
              <section className="mb-5">
                <div className="d-flex align-items-center mb-3">
                  <span
                    className="bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center"
                    style={{ width: "32px", height: "32px", fontSize: "16px" }}
                  >
                    1.0
                  </span>
                  <h3 className="h5 fw-bold ms-3 mb-0">ORDER CONFIRMATION</h3>
                </div>
                <div className="ps-5">
                  <p className="text-secondary mb-3">
                    Orders are confirmed only after successful payment
                    processing. Upon confirmation, you will receive:
                  </p>
                  <ul className="text-secondary">
                    <li className="mb-2">
                      Order confirmation email with unique order ID
                    </li>
                    <li className="mb-2">
                      Digital invoice/receipt for your records
                    </li>
                    <li className="mb-2">Estimated delivery timeline</li>
                    <li className="mb-2">
                      Order summary with itemized details
                    </li>
                  </ul>
                  <div className="bg-warning bg-opacity-10 p-3 rounded-3 mt-3">
                    <small className="text-warning-dark">
                      <i className="bi bi-info-circle me-2"></i>
                      Note: Orders placed on weekends or holidays will be
                      processed on the next business day.
                    </small>
                  </div>
                </div>
              </section>

              {/* Section 2 - Order Processing */}
              <section className="mb-5">
                <div className="d-flex align-items-center mb-3">
                  <span
                    className="bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center"
                    style={{ width: "32px", height: "32px", fontSize: "16px" }}
                  >
                    2.0
                  </span>
                  <h3 className="h5 fw-bold ms-3 mb-0">ORDER PROCESSING</h3>
                </div>
                <div className="ps-5">
                  <p className="text-secondary mb-3">
                    Our order processing timeline follows these standards:
                  </p>
                  <table className="table table-bordered bg-light">
                    <thead className="table-secondary">
                      <tr>
                        <th scope="col">Process Stage</th>
                        <th scope="col">Timeframe</th>
                        <th scope="col">Status Update</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Payment Verification</td>
                        <td>Within 1 hour</td>
                        <td>
                          <span className="badge bg-success">Verified</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Order Processing</td>
                        <td>2-5 business days</td>
                        <td>
                          <span className="badge bg-warning">Processing</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Quality Check</td>
                        <td>24 hours</td>
                        <td>
                          <span className="badge bg-info">Quality Check</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Handover to Courier</td>
                        <td>Within 48 hours</td>
                        <td>
                          <span className="badge bg-primary">Dispatched</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </section>

              {/* Section 3 - Shipping Information */}
              <section className="mb-5">
                <div className="d-flex align-items-center mb-3">
                  <span
                    className="bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center"
                    style={{ width: "32px", height: "32px", fontSize: "16px" }}
                  >
                    3.0
                  </span>
                  <h3 className="h5 fw-bold ms-3 mb-0">SHIPPING INFORMATION</h3>
                </div>
                <div className="ps-5">
                  <div className="row">
                    <div className="col-md-6">
                      <h6 className="fw-bold">Domestic Shipping</h6>
                      <ul className="text-secondary">
                        <li>Metro Cities: 3-5 business days</li>
                        <li>Regional Areas: 5-7 business days</li>
                        <li>Remote Locations: 7-10 business days</li>
                      </ul>
                    </div>
                    <div className="col-md-6">
                      <h6 className="fw-bold">International Shipping</h6>
                      <ul className="text-secondary">
                        <li>Standard: 10-15 business days</li>
                        <li>Express: 5-7 business days</li>
                        <li>Customs clearance may apply</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </section>

              {/* Section 4 - Order Cancellation */}
              <section className="mb-5">
                <div className="d-flex align-items-center mb-3">
                  <span
                    className="bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center"
                    style={{ width: "32px", height: "32px", fontSize: "16px" }}
                  >
                    4.0
                  </span>
                  <h3 className="h5 fw-bold ms-3 mb-0">ORDER CANCELLATION</h3>
                </div>
                <div className="ps-5">
                  <p className="text-secondary mb-3">
                    Orders can be cancelled subject to the following conditions:
                  </p>
                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <div className="border rounded-3 p-3 text-center h-100">
                        <div
                          className="bg-success bg-opacity-10 text-success rounded-circle d-inline-flex align-items-center justify-content-center mb-2"
                          style={{ width: "48px", height: "48px" }}
                        >
                          <i className="bi bi-check-circle fs-4"></i>
                        </div>
                        <h6 className="fw-bold">Within 24 Hours</h6>
                        <small className="text-secondary">
                          Full refund, no questions asked
                        </small>
                      </div>
                    </div>
                    <div className="col-md-4 mb-3">
                      <div className="border rounded-3 p-3 text-center h-100">
                        <div
                          className="bg-warning bg-opacity-10 text-warning rounded-circle d-inline-flex align-items-center justify-content-center mb-2"
                          style={{ width: "48px", height: "48px" }}
                        >
                          <i className="bi bi-clock-history fs-4"></i>
                        </div>
                        <h6 className="fw-bold">24-48 Hours</h6>
                        <small className="text-secondary">
                          Partial refund may apply
                        </small>
                      </div>
                    </div>
                    <div className="col-md-4 mb-3">
                      <div className="border rounded-3 p-3 text-center h-100">
                        <div
                          className="bg-danger bg-opacity-10 text-danger rounded-circle d-inline-flex align-items-center justify-content-center mb-2"
                          style={{ width: "48px", height: "48px" }}
                        >
                          <i className="bi bi-x-circle fs-4"></i>
                        </div>
                        <h6 className="fw-bold">After 48 Hours</h6>
                        <small className="text-secondary">
                          Cancellation not guaranteed
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              {/* Section 5 - Important Terms */}
              <section className="mb-5">
                <div className="d-flex align-items-center mb-3">
                  <span
                    className="bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center"
                    style={{ width: "32px", height: "32px", fontSize: "16px" }}
                  >
                    5.0
                  </span>
                  <h3 className="h5 fw-bold ms-3 mb-0">IMPORTANT TERMS</h3>
                </div>
                <div className="ps-5">
                  <div className="bg-light p-4 rounded-3">
                    <ul className="list-unstyled mb-0">
                      <li className="mb-2">
                        <i className="bi bi-dot text-primary me-2"></i>
                        Bulk orders require additional verification (3-5
                        business days)
                      </li>
                      <li className="mb-2">
                        <i className="bi bi-dot text-primary me-2"></i>
                        International orders may be subject to customs duties
                      </li>
                      <li className="mb-2">
                        <i className="bi bi-dot text-primary me-2"></i>
                        Proof of delivery required for lost package claims
                      </li>
                      <li className="mb-2">
                        <i className="bi bi-dot text-primary me-2"></i>
                        Order policy subject to change without prior notice
                      </li>
                    </ul>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>

      {/* Bootstrap Icons */}
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css"
      />

      <Footer />
    </>
  );
};

export default OrderPolicy;
